import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { WarehouseReceivingLayout } from "@/screens/WarehouseReceiving/components"
import { uomLoader } from "@/screens/WarehouseReceiving/loaders"

export const Route = createFileRoute("/app/warehouse-receiving/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSE_RECEIVING_VIEW]}>
      <WarehouseReceivingLayout />
    </PermissionContentWrapper>
  ),
})
